import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LayoutService } from '../../@core/services/theme/layout.service';
import theme from '../../@core/utils/tailwindcss';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '../../@core/utils/check-router-childs-data';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ConfigService } from '../../@core/services/theme/config.service';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { SidebarComponent } from '../../@core/components/sidebar/sidebar.component';
import { AppService } from 'src/@core/services/app.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  @Input() mobileQuery: boolean;
  @Input() footerRef: TemplateRef<any>;
  showWhatsAppButton: boolean = true;



  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
  isFooterVisible$ = this.configService.config$.pipe(map(config => config.footer.visible));
  isDesktop$ = this.breakpointObserver.observe(`(min-width: ${theme.screens.lg})`).pipe(
    map(state => state.matches)
  );

  toolbarShadowEnabled$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    startWith(null),
    map(() => checkRouterChildsData(this.router.routerState.root.snapshot, data => data.toolbarShadowEnabled))
  );

  @ViewChild('configpanel', { static: true }) configpanel: SidebarComponent;
  profile = this.appService.getCurrentAccount();
  hideSidePanel: boolean = false;

  constructor(private layoutService: LayoutService,
    private configService: ConfigService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private appService: AppService) {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const hiddenUrls = ['/job/create-project', '/enterprise-admin/create-work-order'];
      this.showWhatsAppButton = !hiddenUrls.some(url => event.url.includes(url));
    });

  }

  ngOnInit() {
    this.hideSidePanel = false;
    console.log(this.router.url, this.profile)
    if (this.profile && !this.profile.user && this.router.url.includes("marketplace")) {
      this.hideSidePanel = true;
    }
    if (!this.profile && this.router.url.includes("marketplace")) {
      this.hideSidePanel = true;
    }
    console.log("###################", this.hideSidePanel)
    // this.layoutService.configpanelOpen$.pipe(
    //   untilDestroyed(this)
    // ).subscribe(open => open ? this.configpanel.open() : this.configpanel.close());
  }

  ngOnDestroy(): void { }
}
